import { createAction } from 'redux-actions';

export const startChat = createAction('START_CHAT', ({ token }) => ({ token }));

export const updateChatToken = createAction('UPDATE_CHAT_TOKEN', token => ({
  token,
}));

export const endChat = createAction('END_CHAT');
